'use strict';
define(['jquery'], function () {
    function StructureController($scope, $state) {
        if ($scope.loading) {
            $state.go('app.seochecker.results.overview');
            return;
        }
        if ($scope.baseCategories) {
            $scope.categories = $scope.baseCategories;

            $scope.categoriesWithExams = {};
            
            for (var property in $scope.categories) {
                $scope.categoriesWithExams[property] = {
                    categoryId: property,
                    exams: []
                };  
            }
                        
            for (var exam in $scope.base.exams) { 
                for (var property in $scope.categories) {
                    if ($scope.categories.hasOwnProperty(property)) {
                        if ($scope.categories[property].indexOf(exam) != -1) {
                            $scope.categoriesWithExams[property].exams.push($scope.base.exams[exam]);
                        }
                    }
                }
            }
        }
        
    }
    StructureController.$inject = ['$scope', '$state'];
    return StructureController;
});
